export default {
  name: 'Checkbox',

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    required: Boolean,
    text: String,
    html: String,
  },

  watch: {
    value() {
      this.inputValue = this.value;
    },
  },

  methods: {
    onChangeInput() {
      this.inputValue = !this.inputValue;
      this.$emit('onChange', this.inputValue);
      this.$emit('input', this.inputValue);
      this.isError = false;
    },

    validate() {
      if (this.required && !this.inputValue) {
        this.errorMessage = 'must_be_accepted';
        this.isError = true;
      }

      return !this.isError;
    },
  },

  data() {
    return {
      inputValue: this.value,
      isInputDisabled: this.isInputDisabled || false,
      isError: false,
      errorMessage: '',
    };
  },
};
